module.exports = __webpack_public_path__ + "img/66F_รูปหน้าคน-ผู้หญิง_lip.1ab8e4ce.png";